module.exports = __webpack_public_path__ + "img/chinesecompany119.73927a47.png";